document.addEventListener('DOMContentLoaded', function () {
  const privilegeContact = document.querySelector('.js-privilege-contact');
  
  if (privilegeContact) {
    privilegeContact.addEventListener('click', function (e) {
      const drawer = document.querySelector(".drawer-menu-sticky .drawer-menu");
      let form;

      if (e.currentTarget.classList.contains('js-contact-conciergerie-form')) {
        form = document.querySelector('.js-contact-conciergerie');
      }

      if (e.currentTarget.classList.contains('js-contact-advisor-form')) {
        form = document.querySelector('.js-contact-advisor');
      }

      if (form) {
        document.querySelector('.drawer-menu__close-icon').click();
        form.click();
      }
    });
  }
});